export default {
  bible: () => import("/vercel/path0/bible-assistant/layouts/bible.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/bible-assistant/layouts/default.vue").then(m => m.default || m),
  test: () => import("/vercel/path0/bible-assistant/layouts/test.vue").then(m => m.default || m)
}